export const carouselWithButtons = (
  carouselModule,
  carouselItems,
  carousel,
  $,
  mobileSlideCount,
  tabletSlideCount,
  desktopSlideCount
) => {
  if (!carouselModule) {
    return;
  }

  let numOfItems = $(carouselItems).length;
  const relatedVideosCarousel = $(carousel).slick({
    infinite: false,
    arrows: false,
    variable: false,
    slidesToShow: desktopSlideCount,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: mobileSlideCount,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: tabletSlideCount,
        },
      },
    ],
  });
  const relatedVideosCarouselArrows = $(`${carouselModule} .arrow`);
  const relatedVideosCarouselPrevArrow = $(`${carouselModule} .arrow--prev`);
  const relatedVideosCarouselNextArrow = $(`${carouselModule} .arrow--next`);
  relatedVideosCarouselPrevArrow.on("click keydown", function (e) {
    var keyCode = e.keyCode ? e.keyCode || e.which : null;
    if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
      relatedVideosCarousel.slick("slickPrev");
    }
  });
  relatedVideosCarouselNextArrow.on("click keydown", function (e) {
    var keyCode = e.keyCode ? e.keyCode || e.which : null;
    if (e.type === "click" || (e.type === "keydown" && keyCode == 13)) {
      relatedVideosCarousel.slick("slickNext");
    }
  });

  relatedVideosCarouselNextArrow.attr("tabindex", 0);
  relatedVideosCarouselPrevArrow.attr("tabindex", 0);
  relatedVideosCarousel.on("afterChange", function (nextSlide) {
    const nextSlideNum = nextSlide.currentTarget.slick.currentSlide;
    const slidesToShowNum = nextSlide.currentTarget.slick.options.slidesToShow;

    if (nextSlideNum === 0) {
      relatedVideosCarouselPrevArrow.addClass("disabled");
      relatedVideosCarouselNextArrow.removeClass("disabled");
    } else if (nextSlideNum === numOfItems - slidesToShowNum) {
      relatedVideosCarouselPrevArrow.removeClass("disabled");
      relatedVideosCarouselNextArrow.addClass("disabled");
    } else {
      relatedVideosCarouselPrevArrow.removeClass("disabled");
      relatedVideosCarouselNextArrow.removeClass("disabled");
    }
  });

  const showHideRelatedVideoArrows = () => {
    if (relatedVideosCarousel.length > 0) {
      const left = $(`${carousel} .slick-track`).offset().left;
      if ($(`${carousel} .slick-track`).width() + left > window.innerWidth) {
        relatedVideosCarouselArrows.show();
      } else {
        relatedVideosCarouselArrows.hide();
      }
    }
  };

  $(window).resize(function () {
    showHideRelatedVideoArrows();
  });

  showHideRelatedVideoArrows();

  // *****************
  // Take Related video's video title from iframe and apply it to title
  // element outside iframe below
  // *****************
  if (carouselModule === ".related-videos") {
    $(".related-videos .video iframe").on("load", function () {
      const title = $(this)[0].title;
      const parent = $(this).parent();
      parent.siblings(".title").text(title);
    });
  }
};
